var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"z-checkbox",class:{
        'is-checked': _vm.check,
        'is-disabled': _vm.disabled
    },attrs:{"for":_vm.name}},[_c('input',{ref:"checkbox",attrs:{"id":_vm.name,"name":_vm.name,"disabled":_vm.disabled,"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.change($event.target.checked)}}}),_vm._v(" "),_c('span',{staticClass:"z-checkbox__box"}),_vm._v(" "),_c('span',{staticClass:"z-checkbox__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }